import React, { useCallback } from 'react';
import styled from '@emotion/styled';
import { SectionKeywordDto } from '@diritto/common/relay/dtos/section-relay.dtos';
import { Typography } from '@diritto/common/style/typography';
import { TrackerExtraInfoProps, TrackingEventType } from '@diritto/common/tracker/tracking-event.constant';
import { useTrackingState } from 'contexts/TrackingProvider';
import { SectionContentKeyword } from 'app-components/home/sections/components/SectionContentKeyword';
import { SectionTitle } from 'app-components/home/sections/components/SectionTitle';

interface SectionSearchKeywordsProps {
  section: SectionKeywordDto;
}

export const SectionSearchKeywords = ({
  section,
  trackerExtraInfo,
}: SectionSearchKeywordsProps & TrackerExtraInfoProps) => {
  const { tracker } = useTrackingState();
  const keywords = section.keywords ?? [];

  const handleClick = useCallback(
    (keyword: string) => {
      tracker.track(TrackingEventType.ClickSectionKeyword, { keyword });
    },
    [tracker],
  );

  return (
    <div>
      <SectionTitle section={section} moreLink={section.moreLink} trackerExtraInfo={trackerExtraInfo} />
      <StyledWrapper>
        {keywords.map(it => (
          <StyledKeywordWrapper
            variant={'search'}
            keyword={it}
            key={`section-keyword-${it}`}
            onClick={() => handleClick(it)}
          />
        ))}
      </StyledWrapper>
    </div>
  );
};

const StyledWrapper = styled.div`
  position: relative;
  padding: 0 16px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  row-gap: 8px;
`;

const StyledKeywordWrapper = styled(SectionContentKeyword)`
  border-radius: 6px;
  padding: 4px 8px;
  margin-right: 8px;
  ${Typography.XXSmall};
`;
